import { css } from "aphrodite";
import styles from "./styles";
import { Box, Button, Typography } from "@mui/material";
import theme from "../../../common/theme/mellon";

const CustomMobileServiceButton = ({
    isSelected,
    extraValue,
    value,
    extraValueVisible = false,
    onClickButton = () => {}
}) => {

    
    return (
        <div className={css(styles.container)}>
            <Box
                sx={{
                    background: isSelected
                        ? theme.palette.secondary.main
                        : theme.palette.primary.main,
                }}
                className={css(styles.buttonDiv)}
            >
                <Button
                    className={css(styles.valueButton)}
                    color="inherit"
                    onClick={onClickButton}
                    aria-pressed={Boolean(isSelected)}
                >
                    <Typography color="white"  className={css(styles.textStyle)}>
                        {value}
                    </Typography>
                </Button>
                
            </Box>            
        </div>
    );
};

export default CustomMobileServiceButton;
